import React, { useEffect, useRef, useState } from "react";
import {
  Row,
  Col,
  Select,
  Button,
  Table,
  Popconfirm,
  Tooltip,
  Input,
  Modal,
  Form,
  DatePicker,
  Card,
  InputNumber,
  Tag,
  Radio,
  Space,
  Dropdown,
  Menu,
  notification,
  Popover,
  Checkbox
} from "antd";
import "../Pages/CSS/DonnesBases.css";
import "../Pages/CSS/Traitement.css";
import { BpiService } from "../Services/BpiService";
import * as XLSX from "xlsx";
import {
  CalculatorOutlined,
  CalendarOutlined,
  CheckCircleOutlined,
  DeleteFilled,
  DownOutlined,
  EditOutlined,
  MoreOutlined,
  PlusOutlined,
  SyncOutlined,
  UndoOutlined,
  DollarOutlined,
} from "@ant-design/icons";
import FacturePdf from "./FacturePdf";
import { AdherentsService } from "../Services/AdherentsService";
import "moment/locale/fr";
import moment from "moment";
import dayjs from "dayjs";
import { ExerciceDocService } from "../Services/ExerciceDocService";
import Draggable from "react-draggable";
import { ReglementsService } from "../Services/ReglementsService";
moment.locale("fr");
const { Option } = Select;
const { confirm } = Modal;


const DraggableModal = ({ children, ...props }) => {
  const [disabled, setDisabled] = useState(true);
  const draggleRef = useRef(null);

  return (
    <Modal
      {...props}
      modalRender={(modal) => (
        <Draggable
          disabled={disabled}
          bounds={draggleRef.current ? draggleRef.current : undefined}
          handle=".ant-modal-title"
        >
          <div ref={draggleRef}>{modal}</div>
        </Draggable>
      )}
      title={
        <div
          className="ant-modal-title"
          style={{ width: "100%", cursor: "move" }}
          onMouseOver={() => setDisabled(false)}
          onMouseOut={() => setDisabled(true)}
        >
          {props.title}
        </div>
      }
    >
      {children}
    </Modal>
  );
};

const FacsSocs = () => {
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [adherents, setAdherents] = useState([]);
  const [selectAdherent, setSelectAdherent] = useState("")
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [refreshTable, setRefreshTable] = useState(false);
  const [years, setYears] = useState([]);
  const [currentFacture, setCurrentFacture] = useState(null);
  const [pageSize, setPageSize] = useState(10);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedOption, setSelectedOption] = useState("waiting");
  // const [isEditingEnabled, setIsEditingEnabled] = useState(false);
  const [isRgFactEnabled, setIsRgFactEnabled] = useState(false);
  const [isComptaEnabled, setIsComptaEnabled] = useState(false);
  const [isAnRegEnabled, setIsAnRegEnabled] = useState(false);
  const [isAnPayeEnabled, setIsAnPayeEnabled] = useState(false);
  /*  const [isPayingEnabled, setIsPayingEnabled] = useState(false);
 const [isOtherButtonsEnabled, setIsOtherButtonsEnabled] = useState(false);
   const [isMassTransferEnabled, setIsMassTransferEnabled] = useState(false); */
  const [modalVisible, setModalVisible] = useState(false);
  const [journalRegData, setJournalRegData] = useState([]);
  const [paramsDetails, setParamsDetails] = useState(null);
  const [selectedDate, setSelectedDate] = useState(dayjs());
  const [selectedTypeReglement, setSelectedTypeReglement] = useState(null);
  const [montantsModifies, setMontantsModifies] = useState({});
  const [montantEncaissement, setMontantEncaissement] = useState(0);
  const [totalFacturesInitial, setTotalFacturesInitial] = useState(0);
  const [comptaPreviewData, setComptaPreviewData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isTypeRegDisabled, setIsTypeRegDisabled] = useState(false);
  const [solde, setSolde] = useState(0);
  const [isEditMode, setIsEditMode] = useState(false);
  const getSelectedYear = () => {
    const currentYear = new Date().getFullYear();
    return currentYear.toString();
  };
  const [selectedYear, setSelectedYear] = useState(getSelectedYear());
  const [filteredData, setFilteredData] = useState([]);
  const [montantNet, setMontantNet] = useState(0);

  const getSelectedMonth = () => {
    const currentMonth = new Date().getMonth() + 1;
    return currentMonth.toString();
  };
  const [selectedMonth, setSelectedMonth] = useState(getSelectedMonth());

  const months = [
    { value: "1", label: "Janvier" },
    { value: "2", label: "Février" },
    { value: "3", label: "Mars" },
    { value: "4", label: "Avril" },
    { value: "5", label: "Mai" },
    { value: "6", label: "Juin" },
    { value: "7", label: "Juillet" },
    { value: "8", label: "Août" },
    { value: "9", label: "Septembre" },
    { value: "10", label: "Octobre" },
    { value: "11", label: "Novembre" },
    { value: "12", label: "Décembre" },
  ];

  const exerciceDocService = new ExerciceDocService();
  const adherentsService = new AdherentsService();
  const reglementService = new ReglementsService();
  const bpiService = new BpiService();
  const [form] = Form.useForm();

  const userId = localStorage.getItem('login');

  useEffect(() => {
    setLoading(true);
    bpiService
      .getAllEncaissement(selectedYear, selectedMonth)
      .then((data) => {
        setTableData(data);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
    // eslint-disable-next-line
  }, [refreshTable, selectedYear, selectedMonth]);

  // Fonction centralisée pour appliquer les filtres sur le client
  const applyFilters = (data) => {
    let filtered = data;

    // Filtre par état (selectedOption)
    if (selectedOption !== "TT") {
      filtered = filtered.filter((item) => item.etape_encaiss === selectedOption);
    }

    // Filtre par adhérent
    if (selectAdherent) {
      filtered = filtered.filter((item) => item.codesoc === selectAdherent);
    }

    return filtered;
  };

  useEffect(() => {
    const filtered = applyFilters(tableData);
    setFilteredData(filtered);
  }, [tableData, selectAdherent, selectedOption]);

  const handleRefresh = () => {
    setRefreshTable(!refreshTable);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const yearsData = await exerciceDocService.getAllExercicesDoc();
        setYears([...yearsData].sort((a, b) => b - a));
      } catch (error) {
        console.error("Erreur lors de la récupération des données :", error);
      }
    };

    fetchData();
  }, []);

  const handleDeleteline = async (num_facture) => {
    try {
      confirm({
        title: "Êtes-vous sûr de vouloir supprimer cette prestation ?",
        okText: "Oui",
        cancelText: "Non",
        onOk: async () => {
          try {
            await bpiService.deleteFac(num_facture);
            const updatedData = filteredData.filter(
              (item) => item.num_facture !== num_facture
            );
            setFilteredData(updatedData);
          } catch (error) {
            console.error("Erreur lors de la suppression du document :", error);
          }
        },
        onCancel() {
          // Annulation
        },
      });
    } catch (error) {
      console.error(
        "Erreur lors de la confirmation de la suppression :",
        error
      );
    }
  };

  function formatNumber(number) {
    return new Intl.NumberFormat("fr-FR").format(number);
  }

  //Filtre recherche
  const handleSearch = (value) => {
    const filtered = tableData.filter((item) =>
      Object.values(item).some(
        (val) =>
          val && val.toString().toLowerCase().includes(value.toLowerCase())
      )
    );

    setFilteredData(filtered); // Mettre à jour les données filtrées
  };

  const fetchAdherents = async () => {
    try {
      const adherentsData = await adherentsService.getAllAdherents();
      setAdherents(adherentsData);
    } catch (error) {
      console.error("Erreur lors de la récupération des adhérents :", error);
    }
  };

  useEffect(() => {
    fetchAdherents();
  }, []);

  const fetchSaisie = async (type) => {
    try {
      const journalsData = await reglementService.getSaisieReg();
      setJournalRegData(journalsData);
      /* setTypeReglementFourn(
        journalsData.filter((journal) => journal.type === type)
      ); */
    } catch (error) {
      notification.error({
        message: "Erreur lors de la récupération des journaux comptables",
        description: error.message,
      });
    }
  };

  const loadParams = async () => {
    try {
      const data = await reglementService.getParamReg();
      setParamsDetails(data);
    } catch (error) {
      console.error("Erreur lors de la récupération des données", error);
    }
  };

  useEffect(() => {
    if (paramsDetails && paramsDetails.datedeb) {
      setSelectedDate(dayjs(paramsDetails.datedeb));
    } else {
      setSelectedDate(dayjs());
    }
  }, [paramsDetails]);

  useEffect(() => {
    form.setFieldsValue({
      date_trait: selectedDate.format("MMM-YYYY"),
    });
  }, [selectedDate, form]);

  /* const onchangeAdhenrent = (value) => {
    setSelectAdherent(value);
  
   
    const filtered = value
      ? tableData.filter((item) => item.codesoc === value)
      : tableData; 
  
    setFilteredData(filtered); 
  }; */

  const onchangeAdhenrent = (value) => {
    setSelectAdherent(value);
  };


  const exportToExcel = () => {
    const dataToExport = filteredData.map((item) => ({
      "Code soc.": item.codesoc,
      Société: item.societe,
      Date: item.date_facture,
      "N° facture": item.num_facture,
      Période: item.periode,
      "Nb. Part.": item.nb_participants,
      "Montant cotis.": item.montant_cotis,
      "Montant FM": item.montant_fm,
    }));

    const ws = XLSX.utils.json_to_sheet(dataToExport);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Factures");

    XLSX.writeFile(wb, "factures.xlsx");
  };

  const exportExcel = (data, fileName) => {
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, `${fileName}.xlsx`);
  };

  const showModal = (record = null) => {
    fetchAdherents();
    if (record) {
      form.setFieldsValue({
        codesoc: record.codesoc,
        date_facture: dayjs(moment(record.date_facture)),
        date_envoi: dayjs(moment(record.date_envoi)),
        montant_cotis_pat: record.montant_cotis_pat ?? 0,
        montant_cotis_sal: record.montant_cotis_sal ?? 0,
        montant_fm: record.montant_fm ?? 0,
        montant_adh: record.montant_adh ?? 0,
        montant_sub: record.montant_sub ?? 0,
        montant_net: record.montant_net ?? 0,
        periode: dayjs(moment(record.periode)),
        nb_participants: record.nb_participants ?? 0, // Si le nombre de participants est vide, affiche 0
      });

      setCurrentFacture(record);
    } else {
      form.resetFields();
      form.setFieldsValue({
        date_facture: dayjs(moment()), // Date d'aujourd'hui
        date_envoi: dayjs(moment()),
        periode: dayjs(moment()), // Date d'aujourd'hui
        montant_cotis_pat: 0,
        montant_cotis_sal: 0,
        montant_fm: 0,
        montant_adh: 0,
        montant_sub: 0,
        montant_net: 0,
        nb_participants: 0,
      });
      setCurrentFacture(null);
    }
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    form.resetFields();
    setCurrentFacture(null);
    setIsModalVisible(false);
  };

  const handleYearChange = (value) => {
    setSelectedYear(value);
    setSelectedRowKeys([]); // Réinitialiser la sélection
  };

  const handleMonthChange = (value) => {
    setSelectedMonth(value);
    setSelectedRowKeys([]); // Réinitialiser la sélection
  };
  const stateConfig = {
    waiting: {
      isEditingEnabled: true,
      isPayingEnabled: true,
      isMassTransferEnabled: false,
      isComptaEnabled: false,
      isAnPayeEnabled: false,
      isAnRegEnabled: false,
      isRgFactEnabled: true,
    },
    paid: {
      isEditingEnabled: true,
      isPayingEnabled: false,
      isMassTransferEnabled: true,
      isComptaEnabled: true,
      isAnPayeEnabled: true,
      isAnRegEnabled: false,
      isRgFactEnabled: false,
      isOtherButtonsEnabled: true,
    },
    /*   paid: {
        isEditingEnabled: true,
        isPayingEnabled: false,
        isMassTransferEnabled: true,
        isComptaEnabled: true,
        isAnPayeEnabled: false,
        isAnRegEnabled: false,
        isRgFactEnabled: false,
      }, */
    done: {
      isEditingEnabled: true,
      isPayingEnabled: false,
      isMassTransferEnabled: true,
      isComptaEnabled: false,
      isAnPayeEnabled: false,
      isAnRegEnabled: true,
      isRgFactEnabled: false,
    },
    /*  NN: {
       isEditingEnabled: true,
       isPayingEnabled: true,
       isMassTransferEnabled: true,
       isComptaEnabled: false,
       isAnPayeEnabled: false,
       isAnRegEnabled: false,
       isRgFactEnabled: false,
     }, */
  };




  /*  const handleOptionChange = (e) => {
     const newOption = e.target.value;
     setSelectedOption(newOption);
   
     if (newOption === "TT") {
       setFilteredData(tableData); // Afficher toutes les lignes
     } else {
       // Filtrer selon l'état choisi
       const filtered = tableData.filter((item) => item.etape_encaiss === newOption);
       setFilteredData(filtered);
     }
   }; */
  const handleOptionChange = (e) => {
    const newOption = e.target.value;
    setSelectedOption(newOption);
    setSelectedRowKeys([]); // Réinitialiser la sélection
  };


  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);

    const hasSelectedRows = newSelectedRowKeys.length > 0;
    if (hasSelectedRows) {
      const selectedState = stateConfig[selectedOption] || {};
      //setIsEditingEnabled(selectedState.isEditingEnabled);
      // setIsPayingEnabled(selectedState.isPayingEnabled);
      // setIsMassTransferEnabled(selectedState.isMassTransferEnabled);
      setIsComptaEnabled(selectedState.isComptaEnabled);
      //setIsAnPayeEnabled(selectedState.isAnPayeEnabled);
      setIsAnRegEnabled(selectedState.isAnRegEnabled);
      setIsRgFactEnabled(selectedState.isRgFactEnabled);
      // setIsOtherButtonsEnabled(selectedState.isOtherButtonsEnabled);
    } else {
      // setIsEditingEnabled(false);
      //  setIsPayingEnabled(false);
      //  setIsMassTransferEnabled(false);
      setIsComptaEnabled(false);
      //setIsAnPayeEnabled(false);
      setIsAnRegEnabled(false);
      setIsRgFactEnabled(false);
      // setIsOtherButtonsEnabled(false);
    }
  };

  const allRowKeys = filteredData.map((record) => record.num_encaiss);

  const handleSelectAllChange = (e) => {
    setSelectedRowKeys(e.target.checked ? allRowKeys : []);
  };

  const rowSelection = {
    selectedRowKeys,
    columnTitle: (
      <Checkbox
        checked={allRowKeys.length > 0 && selectedRowKeys.length === allRowKeys.length}
        indeterminate={selectedRowKeys.length > 0 && selectedRowKeys.length < allRowKeys.length}
        onChange={handleSelectAllChange}
      />
    ),
    onChange: onSelectChange, // Utilisation de la fonction nommée
    /*   selections: [
        {
          key: "select-all",
          text: "Sélectionner toutes les lignes",
          onSelect: () => {
            const allKeys = filteredData.map((item) => item.num_encaiss);
            setSelectedRowKeys(allKeys);
            onSelectChange(allKeys); // Appel explicite pour inclure la logique de validation
          },
        },
        {
          key: "clear-selection",
          text: "Désélectionner toutes les lignes",
          onSelect: () => {
            setSelectedRowKeys([]);
            onSelectChange([]); // Appel explicite avec un tableau vide
          },
        },
      ],
  
      getCheckboxProps: (record) => ({
        name: record.num_encaiss,
      }), */
  };
  const handleTypeReglementChange = (value) => {
    setSelectedTypeReglement(value);
  };
  const typeReglementLabels = {
    V: "Virement",
    C: "Chèque",
    Compte: "Compte Avance",
    E: "Espèce",
    T: "Transfert",
  };
  const handleModalCancel = () => {
    setModalVisible(false); // Ferme le modal
    setSelectedTypeReglement(null); // Réinitialise le type de règlement
    form.resetFields(["type_encaiss", "num_cheque", "code_bque"]); // Réinitialise les champs du formulaire
    setSolde(0); // Réinitialise le solde affiché

    // Réinitialiser les montants
    setMontantsModifies({});
    setMontantEncaissement(0);
    setTotalFacturesInitial(0);

    // Réinitialiser la sélection des encaissements
    setSelectedRowKeys([]);
  };
  const handleModalOk = async () => {
    try {
      // Vérifier qu'au moins une ligne est sélectionnée
      if (selectedRowKeys.length === 0) {
        notification.warning({
          message: "Sélection requise",
          description: "Veuillez sélectionner au moins une ligne.",
        });
        return;
      }
      // Vérifier si toutes les lignes sélectionnées ont le même `codesoc`
      const selectedRecords = tableData.filter(record =>
        selectedRowKeys.includes(record.num_encaiss)
      );

      /*  const uniqueCodesoc = new Set(selectedRecords.map(record => record.codesoc));
   
       if (uniqueCodesoc.size > 1) {
         notification.error({
           message: "Sélection invalide",
           description: "Veuillez sélectionner des lignes avec le même code société.",
         });
         return;
       } */
      await form.validateFields();
      // Récupérer les valeurs du formulaire
      const formValues = form.getFieldsValue();
      console.log("Valeur de date_trait :", formValues.date_trait);
      // Construire le payload en prenant en compte les modifications
      const payload = selectedRecords.map(record => {
        const montantModifie = montantsModifies[record.num_encaiss] ?? record.montant_encaiss ?? 0;

        // Vérifications des contraintes sur `montant_encaiss`
        if (montantModifie === 0) {
          notification.error({
            message: "Montant invalide",
            description: `Le montant de l'encaissement de ${record.motif_2} ne peut pas être égal à 0.`,
          });
          throw new Error("Montant invalide : 0 non autorisé.");
        }

        if (montantModifie < 0) {
          notification.error({
            message: "Montant invalide",
            description: `Le montant de l'encaissement de ${record.motif_2} ne peut pas être négatif.`,
          });
          throw new Error("Montant invalide : négatif non autorisé.");
        }

        if (montantModifie > record.montant_to_encaiss) {
          notification.error({
            message: "Montant invalide",
            description: `Le montant de l'encaissement de ${record.motif_2} ne peut pas être supérieur à ${record.montant_to_encaiss}.`,
          });
          throw new Error("Montant invalide : supérieur au montant initial.");
        }

        return {
          ...record,
          encaiss_by: userId,
          num_encaiss: record.num_encaiss,
          motif_2: record.motif_2 || "",
          montant_encaiss: montantModifie,
          montant_to_encaiss: record.montant_to_encaiss,
          type_encaiss: formValues.type_encaiss,
          num_cheque: formValues.num_cheque,
          code_bque: formValues.code_bque,
          date_encaiss: formValues.date_encaiss.format("YYYY-MM-DD"),
          date_trait: formValues.date_trait ? dayjs(formValues.date_trait).format("YYYY-MM-DD") : null,
        };
      });

      console.log("Payload envoyé :", payload);
      const response = await reglementService.updateSaisieEncaisse(payload);
      if (response) {
        notification.success({
          message: "Encaissement mis à jour",
          description: "Les modifications ont été enregistrées avec succès.",
        });
        // setModalVisible(false);
        handleModalCancel();
        setRefreshTable(!refreshTable);
      } else {
        notification.error({
          message: "Erreur",
          description: "Une erreur s'est produite lors de l'enregistrement.",
        });
      }
    } catch (error) {
      console.error("Erreur lors de la mise à jour :", error);
    }
  };


  const onFinish = async (values) => {
    const docData = {
      ...values,
      periode: dayjs((values.periode).format("YYYY-MM-DD")),
    };

    if (currentFacture) {
      // Mise à jour
      docData.num_encaiss = currentFacture.num_encaiss;
      try {
        await bpiService.FacEditDoc(docData);
        console.log("Document modifié avec succès");
        // Fermer le modal et rafraîchir les données
        handleCancel();
        setRefreshTable(!refreshTable);
        //   setReloadData(!reloadData);
      } catch (error) {
        console.error("Erreur lors de la modification du document :", error);
      }
    } else {
      // Ajout
      try {
        await bpiService.FacAddDoc(docData);
        console.log("Document ajouté avec succès");
        // Fermer le modal et rafraîchir les données
        handleCancel();
        setRefreshTable(!refreshTable);
        // setReloadData(!reloadData); // Ou toute autre logique de rafraîchissement
      } catch (error) {
        console.error("Erreur lors de l'ajout du document :", error);
      }
    }
  };

  const calculateMontantNet = () => {
    const values = form.getFieldsValue([
      "montant_cotis_pat",
      "montant_cotis_sal",
      "montant_fm",
      "montant_adh",
      "montant_sub"
    ]);

    const montantNetCalc = Object.values(values).reduce(
      (acc, value) => acc + (parseFloat(value) || 0),
      0
    );

    setMontantNet(montantNetCalc); // Met à jour l'affichage
    form.setFieldsValue({ montant_net: montantNetCalc }); // Met à jour le formulaire
  };

  useEffect(() => {
    calculateMontantNet();
  }, [
    form.getFieldValue("montant_cotis_pat"),
    form.getFieldValue("montant_cotis_sal"),
    form.getFieldValue("montant_fm"),
    form.getFieldValue("montant_adh"),
    form.getFieldValue("montant_sub")
  ]);


  const columns = [
    {
      title: "N° facture",
      dataIndex: "numfact_adht",
      key: "numfact_adht",
      align: "center",
      filters: [
        ...new Set(
          filteredData.map((item) => item?.numfact_adht).filter((value) => value) // Éliminer les valeurs `null` ou `undefined`
        )
      ].map((value) => ({
        text: value,
        value: value,
      })),
      onFilter: (value, record) => record.numfact_adht === value,
      sorter: (a, b) => (a.numfact_adht || "").localeCompare(b.numfact_adht || ""),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "Code soc.",
      dataIndex: "codesoc",
      key: "codesoc",
      align: "center",
      filters: [
        ...new Set(
          filteredData.map((item) => item?.codesoc).filter((value) => value) // Éliminer les valeurs `null` ou `undefined`
        )
      ].map((value) => ({
        text: value,
        value: value,
      })),
      onFilter: (value, record) => record.codesoc === value,
      render: (text) => <strong>{text || "N/A"}</strong>, // Gérer les valeurs null ou undefined
      sorter: (a, b) => (a.codesoc || "").localeCompare(b.codesoc || ""),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "Adhérent",
      dataIndex: "intitule",
      key: "intitule",
      filters: [
        ...new Set(
          filteredData.map((item) => item?.intitule).filter((value) => value) // Éliminer les valeurs `null` ou `undefined`
        )
      ].map((value) => ({
        text: value,
        value: value,
      })),
      onFilter: (value, record) => record.intitule === value,
      sorter: (a, b) => (a.intitule || "").localeCompare(b.intitule || ""),
      sortDirections: ["ascend", "descend"],
      render: (text) => <span>{text || ""}</span>, // Gérer les valeurs null ou undefined
    },

    {
      title: "Date D'envoi",
      dataIndex: "date_envoi",
      key: "date_envoi",
      align: "center",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <div style={{ padding: 8 }}>
          <DatePicker
            placeholder="Rechercher une date"
            value={selectedKeys[0] ? dayjs(selectedKeys[0]) : null}
            format="DD/MM/YYYY"
            onChange={(date) => {
              if (date) {
                setSelectedKeys([date.format("YYYY-MM-DD")]);
              } else {
                setSelectedKeys([]);
              }
            }}
            style={{ marginBottom: 8, width: "100%" }}
          />
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Button
              onClick={() => {
                clearFilters();
                confirm();
              }}
              size="small"
              style={{ width: "48%" }}
            >
              Réinitialiser
            </Button>
            <Button
              type="primary"
              onClick={() => confirm()}
              size="small"
              style={{ width: "48%" }}
            >
              Rechercher
            </Button>
          </div>
        </div>
      ),
      onFilter: (value, record) => {
        const recordDate = moment(record.date_envoi).format("YYYY-MM-DD");
        return recordDate === value;
      },
      render: (text) => (
        <span>{text ? moment(text).format("DD/MM/YYYY") : ""}</span>
      ),
      sorter: (a, b) => {
        const dateA = a.date_envoi ? new Date(a.date_envoi) : 0;
        const dateB = b.date_envoi ? new Date(b.date_envoi) : 0;
        return dateA - dateB;
      },
      sortDirections: ["ascend", "descend"],
    },
    ...(selectedOption === "paid" || selectedOption === "done"
      ? [
        {
          title: "Date Encaiss",
          dataIndex: "date_facture",
          key: "date_facture",
          align: "center",
          filterDropdown: ({
            setSelectedKeys,
            selectedKeys,
            confirm,
            clearFilters,
          }) => (
            <div style={{ padding: 8 }}>
              <DatePicker
                placeholder="Rechercher une date"
                value={selectedKeys[0] ? dayjs(selectedKeys[0]) : null}
                format="DD/MM/YYYY"
                disabledDate={(current) => current && current > dayjs().endOf('day')}
                onChange={(date) => {
                  if (date) {
                    setSelectedKeys([date.format("YYYY-MM-DD")]);
                  } else {
                    setSelectedKeys([]);
                  }
                }}
                style={{ marginBottom: 8, width: "100%" }}
              />
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <Button
                  onClick={() => {
                    clearFilters();
                    confirm();
                  }}
                  size="small"
                  style={{ width: "48%" }}
                >
                  Réinitialiser
                </Button>
                <Button
                  type="primary"
                  onClick={() => confirm()}
                  size="small"
                  style={{ width: "48%" }}
                >
                  Rechercher
                </Button>
              </div>
            </div>
          ),
          onFilter: (value, record) => {
            const recordDate = moment(record.date_facture).format("YYYY-MM-DD");
            return recordDate === value;
          },

          render: (text) => (
            <span>{text ? moment(text).format("DD/MM/YYYY") : ""}</span>
          ),
          sorter: (a, b) => {
            const dateA = a.date_facture ? new Date(a.date_facture) : 0;
            const dateB = b.date_facture ? new Date(b.date_facture) : 0;
            return dateA - dateB;
          },
          sortDirections: ["ascend", "descend"],
        },
      ]
      : []),
    {
      title: "J retard.",
      dataIndex: "nbjours",
      key: "nbjours",
      align: "center",
      sorter: (a, b) => a.nbjours - b.nbjours,
    },
    {
      title: "Période",
      dataIndex: "periode",
      key: "periode",
      align: "center",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <div style={{ padding: 8 }}>
          <DatePicker
            placeholder="Rechercher une date"
            value={selectedKeys[0] ? dayjs(selectedKeys[0]) : null}
            format="MMM/YYYY"
            disabledDate={(current) => current && current > dayjs().endOf('day')}
            //  picker="month"
            onChange={(date) => {
              if (date) {
                setSelectedKeys([date.format("YYYY-MM-DD")]);
              } else {
                setSelectedKeys([]);
              }
            }}
            style={{ marginBottom: 8, width: "100%" }}
          />
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Button
              onClick={() => {
                clearFilters();
                confirm();
              }}
              size="small"
              style={{ width: "48%" }}
            >
              Réinitialiser
            </Button>
            <Button
              type="primary"
              onClick={() => confirm()}
              size="small"
              style={{ width: "48%" }}
            >
              Rechercher
            </Button>
          </div>
        </div>
      ),
      onFilter: (value, record) => {
        const recordDate = moment(record.periode).format("YYYY-MM-DD");
        return recordDate === value;
      },
      render: (text) => (
        <span>{text ? moment(text).format("MMM-YYYY") : ""}</span>
      ),
      sorter: (a, b) => {
        const periodA = a.periode ? new Date(a.periode) : 0;
        const periodB = b.periode ? new Date(b.periode) : 0;
        return periodA - periodB;
      },
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "Motif",
      dataIndex: "motif_encaiss",
      key: "motif_encaiss",
      filters: [
        ...new Set(
          filteredData.map((item) => item?.motif_encaiss).filter((value) => value) // Éliminer les valeurs `null` ou `undefined`
        )
      ].map((value) => ({
        text: value,
        value: value,
      })),
      onFilter: (value, record) => record.motif_encaiss === value,
      sorter: (a, b) => (a.motif_encaiss || "").localeCompare(b.motif_encaiss || ""),
      sortDirections: ["ascend", "descend"],
      render: (text) => <span>{text || ""}</span>, // Gérer les valeurs null ou undefined
    },
    ...(selectedOption === "waiting" /* || selectedOption === "done" */
      ? [
        {
          title: "Montant Brut",
          dataIndex: "montant_to_encaiss",
          key: "montant_to_encaiss",
          align: "right",
          filterDropdown: ({
            setSelectedKeys,
            selectedKeys,
            confirm,
            clearFilters,
          }) => (
            <div style={{ padding: 8, width: 200 }}>
              {/* Recherche personnalisée */}
              <Input
                placeholder="Rechercher montant"
                value={selectedKeys[0]}
                onChange={(e) => setSelectedKeys([e.target.value])}
                onPressEnter={() => confirm()}
                style={{ marginBottom: 8 }}
              />
              {/* Plages de filtres prédéfinies */}
              <div style={{ marginBottom: 8 }}>
                <Radio.Group
                  onChange={(e) => {
                    setSelectedKeys([e.target.value]);
                    confirm();
                  }}
                  value={selectedKeys[0]}
                  style={{ display: "flex", flexDirection: "column" }}
                >
                  <Radio value="100-100000">100 - 100,000</Radio>
                  <Radio value="100000-1000000">100,000 - 1,000,000</Radio>
                  <Radio value="1000000-">Plus de 1,000,000</Radio>
                </Radio.Group>
              </div>

              {/* Boutons */}
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <Button
                  onClick={() => {
                    clearFilters();
                    confirm();
                  }}
                  size="small"
                  style={{ width: "48%" }}
                >
                  Reset
                </Button>
                <Button
                  type="primary"
                  onClick={() => confirm()}
                  size="small"
                  style={{ width: "48%" }}
                >
                  Ok
                </Button>
              </div>
            </div>
          ),
          onFilter: (value, record) => {
            if (value.includes("-")) {
              const [min, max] = value.split("-").map(Number);
              if (!max) return record.montant_to_encaiss >= min; // Plus de 1,000,000
              return record.montant_to_encaiss >= min && record.montant_to_encaiss <= max; // Plage spécifique
            }
            const parsedValue = parseFloat(value);
            return record.montant_to_encaiss === parsedValue; // Recherche directe
          },
          render: (text) => <span style={{ paddingRight: "5px" }}> <strong>{formatNumber(text || "")}</strong></span>, // Gérer les valeurs null ou undefined
          sorter: (a, b) => (a.montant_to_encaiss || 0) - (b.montant_to_encaiss || 0),
          sortDirections: ["ascend", "descend"],
        },
      ]
      : []),
    {
      title: "Montant",
      dataIndex: "montant_encaiss",
      key: "montant_encaiss",
      align: "right",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <div style={{ padding: 8, width: 200 }}>
          {/* Recherche personnalisée */}
          <Input
            placeholder="Rechercher montant"
            value={selectedKeys[0]}
            onChange={(e) => setSelectedKeys([e.target.value])}
            onPressEnter={() => confirm()}
            style={{ marginBottom: 8 }}
          />
          {/* Plages de filtres prédéfinies */}
          <div style={{ marginBottom: 8 }}>
            <Radio.Group
              onChange={(e) => {
                setSelectedKeys([e.target.value]);
                confirm();
              }}
              value={selectedKeys[0]}
              style={{ display: "flex", flexDirection: "column" }}
            >
              <Radio value="100-100000">100 - 100,000</Radio>
              <Radio value="100000-1000000">100,000 - 1,000,000</Radio>
              <Radio value="1000000-">Plus de 1,000,000</Radio>
            </Radio.Group>
          </div>

          {/* Boutons */}
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Button
              onClick={() => {
                clearFilters();
                confirm();
              }}
              size="small"
              style={{ width: "48%" }}
            >
              Reset
            </Button>
            <Button
              type="primary"
              onClick={() => confirm()}
              size="small"
              style={{ width: "48%" }}
            >
              Ok
            </Button>
          </div>
        </div>
      ),
      onFilter: (value, record) => {
        if (value.includes("-")) {
          const [min, max] = value.split("-").map(Number);
          if (!max) return record.montant_encaiss >= min; // Plus de 1,000,000
          return record.montant_encaiss >= min && record.montant_encaiss <= max; // Plage spécifique
        }
        const parsedValue = parseFloat(value);
        return record.montant_encaiss === parsedValue; // Recherche directe
      },
      render: (text) => <span style={{ paddingRight: "5px" }}> <strong>{formatNumber(text || "")}</strong></span>, // Gérer les valeurs null ou undefined
      sorter: (a, b) => (a.montant_encaiss || 0) - (b.montant_encaiss || 0),
      sortDirections: ["ascend", "descend"],
    },
    ...(selectedOption === "waiting" /* || selectedOption === "done" */
      ? [
        {
          title: "Solde",
          dataIndex: "solde",
          key: "solde",
          align: "right",
          filterDropdown: ({
            setSelectedKeys,
            selectedKeys,
            confirm,
            clearFilters,
          }) => (
            <div style={{ padding: 8, width: 200 }}>
              {/* Recherche personnalisée */}
              <Input
                placeholder="Rechercher montant"
                value={selectedKeys[0]}
                onChange={(e) => setSelectedKeys([e.target.value])}
                onPressEnter={() => confirm()}
                style={{ marginBottom: 8 }}
              />
              {/* Plages de filtres prédéfinies */}
              <div style={{ marginBottom: 8 }}>
                <Radio.Group
                  onChange={(e) => {
                    setSelectedKeys([e.target.value]);
                    confirm();
                  }}
                  value={selectedKeys[0]}
                  style={{ display: "flex", flexDirection: "column" }}
                >
                  <Radio value="100-100000">100 - 100,000</Radio>
                  <Radio value="100000-1000000">100,000 - 1,000,000</Radio>
                  <Radio value="1000000-">Plus de 1,000,000</Radio>
                </Radio.Group>
              </div>

              {/* Boutons */}
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <Button
                  onClick={() => {
                    clearFilters();
                    confirm();
                  }}
                  size="small"
                  style={{ width: "48%" }}
                >
                  Reset
                </Button>
                <Button
                  type="primary"
                  onClick={() => confirm()}
                  size="small"
                  style={{ width: "48%" }}
                >
                  Ok
                </Button>
              </div>
            </div>
          ),
          onFilter: (value, record) => {
            if (value.includes("-")) {
              const [min, max] = value.split("-").map(Number);
              if (!max) return record.solde >= min; // Plus de 1,000,000
              return record.solde >= min && record.solde <= max; // Plage spécifique
            }
            const parsedValue = parseFloat(value);
            return record.solde === parsedValue; // Recherche directe
          },
          render: (text) => <span style={{ paddingRight: "5px" }}> <strong>{formatNumber(text || "")}</strong></span>, // Gérer les valeurs null ou undefined
          sorter: (a, b) => (a.solde || 0) - (b.solde || 0),
          sortDirections: ["ascend", "descend"],
        },
      ]
      : []),
    ...(selectedOption === "paid" || selectedOption === "done"
      ? [
        {
          title: "M.P",
          dataIndex: "type_encaiss",
          key: "type_encaiss",
          align: "center",
          sorter: (a, b) => a.type_encaiss.localeCompare(b.type_encaiss),
          render: (type_encaiss) => {
            let color = "";
            let text = "";

            if (type_encaiss === "C") {
              color = "#02b4f0";
              text = "C";
            } else if (type_encaiss === "P") {
              color = "#02b4f0";
              text = "P";
            } else if (type_encaiss === "T") {
              color = "#02b4f0";
              text = "T";
            } else if (type_encaiss === "V") {
              color = "#02b4f0";
              text = "V";
            } else if (type_encaiss === "E") {
              color = "#02b4f0";
              text = "E";
            }
            return (
              <div style={{ paddingLeft: 10 }}>
                <Tag color={color} key={type_encaiss}>
                  {text}
                </Tag>
              </div>
            );
          },
        },

        {
          title: "Date Encaiss.",
          dataIndex: "date_encaiss",
          key: "date_encaiss",
          align: "center",
          sorter: (a, b) => a.date_encaiss.localeCompare(b.date_encaiss),
          render: (text, record) => (
            <div
              style={{
                whiteSpace: "nowrap",
                textAlign: "center",
                paddingLeft: "5px",
                paddingRight: "5px",
              }}
            >
              {moment(text).locale("fr").format("DD/MM/YYYY")}
            </div>
          ),
        },
        {
          title: "N° C/V",
          dataIndex: "num_cheque",
          key: "num_cheque",
          align: "center",
          sorter: (a, b) => a.num_cheque.localeCompare(b.num_cheque),
        },
        {
          title: "Bque.",
          dataIndex: "libelle",
          key: "libelle",
          // align: "center",
          sorter: (a, b) => a.libelle.localeCompare(b.libelle),
        },
      ]
      : []),
    {
      title: "État",
      dataIndex: "etape_encaiss",
      key: "etape_encaiss",
      fixed: "right",
      className: "small-cell",
      ellipsis: true,
      align: "center",
      sorter: (a, b) => a.etape_encaiss.localeCompare(b.etape_encaiss),
      render: (etape_encaiss) => {
        let color = "";
        let text = "";
        switch (etape_encaiss) {
          case "waiting":
            color = "#b51804";
            text = "En attente";
            break;
          case "paid":
            color = "#e39c02";
            text = "Encaissée";
            break;
          case "done":
            color = "#059e23";
            text = "Comptabilisée.";
            break;

        }
        return (
          <div style={{ paddingLeft: 10 }}>
            <Tag color={color} key={etape_encaiss}>
              {text}
            </Tag>
          </div>
        );
      },
    },
    /*  {
       title: (
         <div
           style={{
             backgroundColor: "#010f1c",
             color: "white",
             padding: "1px",
           }}
         ></div>
       ),
       dataIndex: "actions",
       key: "actions",
       align: "center",
       fixed: "right",
       render: (text, record) => (
         <span>
           <Tooltip title="Imprimer">
             <FacturePdf num_facture={record.num_facture} />
           </Tooltip>
           <Tooltip title="Modifier">
             <EditOutlined
               style={{ cursor: "pointer", color: "orange", marginRight: 8 }}
               onClick={() => showModal(record)}
             />
           </Tooltip>
   
           <Tooltip title="Supprimer">
             <DeleteFilled
               style={{ cursor: "pointer", color: "red" }}
               onClick={() => handleDeleteline(record.num_facture)}
             />
           </Tooltip>
         </span>
       ),
     }, */
  ];
  const gestionMenu1 = (
    <Menu>
      <Menu.Item icon={<SyncOutlined />} onClick={handleRefresh} key="1">
        Actualiser
      </Menu.Item>
      {/*  <Menu.Item
        icon={<CheckCircleOutlined />}
       // disabled={!isPayingEnabled}
        key="2"
     //   onClick={handleApayerReglement}
      >
        A Encaisser
      </Menu.Item> */}
      <Menu.Item
        icon={<UndoOutlined />}
        disabled={!isComptaEnabled}
        key="3"
      >
        Regénérer Encaissement
      </Menu.Item>
      <Menu.Item
        icon={<UndoOutlined />}
        /*  onClick={handleAnnulationComptabilisation} */
        disabled={!isAnRegEnabled}
        // disabled={!isComptaEnabled}
        key="4"
      >
        Annuler La Comptabilisation.
      </Menu.Item>
    </Menu>
  );
  const openModal = (typeReglement) => {
    if (selectedRowKeys.length > 0) {
      const selectedRecords = tableData.filter((record) =>
        selectedRowKeys.includes(record.num_encaiss)
      );
      const uniqueCodesoc = new Set(selectedRecords.map(record => record.codesoc));

      if (uniqueCodesoc.size > 1) {
        notification.error({
          message: "Sélection invalide",
          description: "Veuillez sélectionner des lignes avec le même code société.",
        });
        return;
      }
      if (typeReglement === "Chèque") {
        const allSameFournisseur = selectedRecords.every(
          (record) => record.numfourn === selectedRecords[0].numfourn
        );
        if (!allSameFournisseur) {
          notification.warning({
            message: "Sélection invalide",
            description:
              "Veuillez sélectionner des lignes avec le même fournisseur.",
          });
          return;
        }
      }

      const totalMontfact = selectedRecords.reduce((acc, record) => {
        return acc + parseFloat(record.montant_cotis || 0);
      }, 0);



      // Si "Virement", sélectionner l'option "V" et désactiver
      if (typeReglement === "Virement") {
        setSelectedTypeReglement("V");
        setIsTypeRegDisabled(true);
        form.setFieldsValue({
          typeReg: "V",
        });
      } else {
        // Si autre type, réinitialiser le champ et ne pas désactiver
        setSelectedTypeReglement(null);
        setIsTypeRegDisabled(false);
        form.setFieldsValue({
          typeReg: undefined, // Cela réinitialise le Select pour afficher le placeholder
        });
      }

      setModalVisible(true);
      loadParams();
      fetchSaisie();

    } else {
      notification.warning({
        message: "Sélection requise",
        description: "Veuillez sélectionner au moins une ligne.",
      });
    }
  };
  const handleCompteRattacheChange = async (value) => {
    try {
      const soldeData = await reglementService.getSoldeReg(value);
      setSolde(soldeData);
    } catch (error) {
      console.error("Erreur lors de la récupération du solde :", error);
    }
  };

  /* const menu = (
    <Menu
      onClick={(e) => {
        // Appelle openModal avec le type de règlement sélectionné
        openModal(e.key);
      }}
    >
      <Menu.Item key="Virement">Virement</Menu.Item>
      <Menu.Item key="Chèque">Chèque</Menu.Item>
    </Menu>
  ); */
  useEffect(() => {
    if (selectedRowKeys.length > 0) {
      // Récupérer les num_encaiss sélectionnés
      const selectedFactures = selectedRowKeys.join(" - ");

      // Récupérer la société de la première facture sélectionnée
      const firstSelectedRecord = tableData.find(record => record.num_encaiss === selectedRowKeys[0]);
      const societe = firstSelectedRecord ? firstSelectedRecord.motif_encaiss : "Aucune";

      // Mettre à jour le champ `libReg`
      form.setFieldsValue({
        libReg: `Encaissement N° ${selectedFactures} / ${societe}`
      });
    } else {
      // Réinitialiser si aucune ligne sélectionnée
      form.setFieldsValue({ libReg: "" });
    }
  }, [selectedRowKeys, tableData]);

  useEffect(() => {
    if (selectedRowKeys.length > 0) {
      const totalInitial = tableData
        .filter((record) => selectedRowKeys.includes(record.num_encaiss))
        .reduce((acc, record) => acc + (record.montant_to_encaiss || 0), 0);

      setTotalFacturesInitial(totalInitial);
      setMontantEncaissement(totalInitial);

      // Stocker les montants dans un état modifiable
      const montantsInitiaux = {};
      selectedRowKeys.forEach((numEncaiss) => {
        const record = tableData.find((item) => item.num_encaiss === numEncaiss);
        montantsInitiaux[numEncaiss] = record?.solde || 0;
      });

      setMontantsModifies(montantsInitiaux);
    } else {
      setTotalFacturesInitial(0);
      setMontantEncaissement(0);
      setMontantsModifies({});
    }
  }, [selectedRowKeys]); // Exécuté seulement quand la sélection change
  const columns1 = [
    {
      title: "C.JL",
      dataIndex: "codej",
      key: "codej",
      align: "center",
      sorter: (a, b) => (a.codej || "").localeCompare(b.codej || ""),
    },
    {
      title: "D. Compta",
      dataIndex: "datecompta",
      key: "datecompta",
      align: "center",
      sorter: (a, b) =>
        (a.datecompta ? moment(a.datecompta).unix() : 0) -
        (b.datecompta ? moment(b.datecompta).unix() : 0),
      render: (text) => (
        <div>{text ? moment(text).format("DD/MM/YYYY") : ""}</div>
      ),
    },
    {
      title: "Mois trait.",
      dataIndex: "datetrait",
      key: "datetrait",
      align: "center",
      sorter: (a, b) =>
        (a.datetrait ? moment(a.datetrait).unix() : 0) -
        (b.datetrait ? moment(b.datetrait).unix() : 0),
      render: (text) => (
        <div>{text ? moment(text).format("MMM.YYYY") : ""}</div>
      ),
    },
    {
      title: "N° pièce",
      dataIndex: "numpiece",
      key: "numpiece",
      align: "center",
      sorter: (a, b) => (a.numpiece || "").localeCompare(b.numpiece || ""),
    },
    {
      title: "N° Chèque",
      dataIndex: "numcheque",
      key: "numcheque",
      align: "center",
      sorter: (a, b) => (a.numcheque || "").localeCompare(b.numcheque || ""),
    },
    {
      title: "N° F. IPM",
      dataIndex: "numfactipm",
      key: "numfactipm",
      align: "center",
      sorter: (a, b) => (a.numfactipm || "").localeCompare(b.numfactipm || ""),
    },
    {
      title: "Cpte. Gen.",
      dataIndex: "comptegen",
      key: "comptegen",
      align: "center",
      sorter: (a, b) => (a.comptegen || "").localeCompare(b.comptegen || ""),
    },
    {
      title: "Cpte. Tiers",
      dataIndex: "comptetiers",
      key: "comptetiers",
      align: "center",
      sorter: (a, b) =>
        (a.comptetiers || "").localeCompare(b.comptetiers || ""),
    },
    {
      title: "Matricule",
      dataIndex: "matri",
      key: "matri",
      align: "center",
      sorter: (a, b) => (a.matri || "").localeCompare(b.matri || ""),
    },
    {
      title: "Libellé",
      dataIndex: "libelle",
      key: "libelle",
      sorter: (a, b) => (a.libelle || "").localeCompare(b.libelle || ""),
    },
    {
      title: "Débit",
      dataIndex: "debit",
      key: "debit",
      align: "right",
      sorter: (a, b) => (a.debit || 0) - (b.debit || 0),
      render: (text) => (
        <div style={{ paddingRight: 5 }}>
          {text && parseFloat(text) !== 0
            ? formatNumber(parseFloat(text))
            : ""}
        </div>
      ),
    },
    {
      title: "Crédit",
      dataIndex: "credit",
      key: "credit",
      align: "right",
      sorter: (a, b) => (a.credit || 0) - (b.credit || 0),
      render: (text) => (
        <div style={{ paddingRight: 5 }}>
          {text && parseFloat(text) !== 0
            ? formatNumber(parseFloat(text))
            : ""}
        </div>
      ),
    },
  ];

  const prepareDataForExport = (data) => {
    return data.map((row) => ({
      CodeJ: row.codej,
      DateCompta: row.datecompta,
      MoisTrait: row.datetrait,
      NumPiece: row.numpiece,
      NumCheque: row.numcheque,
      NumFIPM: row.numfactipm,
      CompteGen: row.comptegen,
      CompteTiers: row.comptetiers,
      Matricule: row.matri,
      Libelle: row.libelle,
      Debit: row.debit,
      Credit: row.credit,
    }));
  };

  const handleComptabiliser = async () => {
    try {
      const selectedRows = tableData.filter((row) =>
        selectedRowKeys.includes(row.num_encaiss)
      );

      // Vérifier que tous les codesoc sont identiques
      const codesocs = selectedRows.map(row => row.codesoc);
      const uniqueCodesocs = new Set(codesocs);
      if (uniqueCodesocs.size > 1) {
        Modal.info({
          title: "Erreur de sélection",
          content: "Veuillez sélectionner des lignes avec le même code société.",
        });
        return;
      }

      // Vérifier que toutes les periodes sont identiques
      const periodes = selectedRows.map(row => row.periode);
      const uniquePeriodes = new Set(periodes);
      if (uniquePeriodes.size > 1) {
        Modal.info({
          title: "Erreur de sélection",
          content: "Veuillez sélectionner des lignes avec la même période.",
        });
        return;
      }

      console.log("Selected Rows: ", selectedRows); // Debugging line

      const data = await reglementService.ComptaEncaissPreviewCompta(selectedRows);
      console.log("Compta Preview Data: ", data); // Debugging line

      setComptaPreviewData(data);
      setIsModalOpen(true);
    } catch (error) {
      console.error(
        "Erreur lors de la récupération des données comptables :",
        error
      );
    }
  };

  const totalDebit1 = comptaPreviewData.reduce(
    (sum, record) => sum + parseFloat(record.debit || 0),
    0
  );
  const totalCredit1 = comptaPreviewData.reduce(
    (sum, record) => sum + parseFloat(record.credit || 0),
    0
  );
  const solde1 = totalDebit1 - totalCredit1;

  const handleValidCompta = async () => {
    try {
      const selectedRows = tableData.filter((row) =>
        selectedRowKeys.includes(row.num_encaiss)
      );
      const payload = {
        comptas: comptaPreviewData,
        encaissements: selectedRows,
      };
      const data = await reglementService.addValidComptaEncaiss(payload);
      setIsModalOpen(false);
      setRefreshTable(!refreshTable);
      // fetchReglementations();
    } catch (error) {
      console.error(
        "Erreur lors de la récupération des données comptables :",
        error
      );
    }
  };

  return (
    <div>
      <Card>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 12,
            padding: "10px 20px",
            background: "linear-gradient(135deg, #1890ff 0%, #0097e6 100%)",
            borderRadius: 10,
            boxShadow: "0 4px 15px rgba(24, 144, 255, 0.3)",
            marginBottom: 16,
          }}
        >
          <DollarOutlined style={{ fontSize: 22, color: "#fff" }} />
          <span
            style={{
              fontSize: 18,
              fontWeight: 600,
              color: "#fff",
              letterSpacing: 0.5,
              margin: 0,
            }}
          >
            Saisie Encaissements
          </span>
        </div>
        <Row justify="space-between" align="middle" style={{ marginBottom: "16px" }}>
          <Col>

            <Space direction="vertical" style={{ textAlign: "left" }}>
              <label>Exercice</label>
              <Select
                className="select-colored-accent"
                style={{
                  width: 120,
                  marginRight: 10,
                  "--select-accent": "#1890ff",
                  "--select-accent-bg": "#e6f4ff",
                  "--select-accent-shadow": "rgba(24, 144, 255, 0.25)",
                }}
                onChange={handleYearChange}
                value={selectedYear}
              >
                {years.map((year) => (
                  <Option key={year} value={year}>
                    {year}
                  </Option>
                ))}
              </Select>
            </Space>

            <Space direction="vertical" style={{ textAlign: "left" }}>
              <label>Mois</label>
              <Select
                className="select-colored-accent"
                style={{
                  width: 120,
                  marginRight: 10,
                  "--select-accent": "#722ed1",
                  "--select-accent-bg": "#f9f0ff",
                  "--select-accent-shadow": "rgba(114, 46, 209, 0.25)",
                }}
                onChange={handleMonthChange}
                value={selectedMonth}
              >
                {months.map((month) => (
                  <Option key={month.value} value={month.value}>
                    {month.label}
                  </Option>
                ))}
              </Select>
            </Space>

            <Space direction="vertical" style={{ textAlign: "left" }}>
              <label>Adhérent</label>
              <Select
                className="select-colored-accent"
                style={{
                  width: 300,
                  "--select-accent": "#52c41a",
                  "--select-accent-bg": "#f6ffed",
                  "--select-accent-shadow": "rgba(82, 196, 26, 0.25)",
                }}
                value={selectAdherent}
                onChange={onchangeAdhenrent}
                showSearch
                filterOption={(input, option) =>
                  option.children.toLowerCase().includes(input.toLowerCase())
                }
              >
                <Option value="">Toutes les Sociétés</Option>
                {adherents.map((adherent) => (
                  <Option key={adherent.codeadht} value={adherent.codeadht}>
                    {`${adherent.codeadht} - ${adherent.intitule}`}
                  </Option>
                ))}
              </Select>
            </Space>
          </Col>
          {/*  <Col>
            <Input
              placeholder="Recherche..."
              bordered={false}
              style={{
                width: 250,
                marginRight: 10,
                borderBottom: "2px solid #030303",
              }}
              onChange={(e) => handleSearch(e.target.value)}
            />

            <Button
              className="buttonRecep"
              icon={<PlusOutlined />}
              style={{ marginRight: 10 }}
              onClick={() => showModal()}
            >
              Ajouter
            </Button>

            <Button
              className="buttonExport"
              onClick={exportToExcel}
              style={{ marginRight: 10 }}
            >
              {" "}
              Export Excel
            </Button>
            <Button
              className="buttonRefresh"
              icon={<SyncOutlined />}
              onClick={handleRefresh}
            ></Button>
          </Col> */}
          <Col /* span={24} */ /* style={{ textAlign: "right" }} */>
            <Row justify="end">

              <Col span={24} style={{ textAlign: "right" }}>
                <div style={{ display: "flex", gap: 8, marginBottom: "1rem" }}>
                  {[
                    // {
                    //   value: "TT",
                    //   label: "Tout",
                    //   activeBackground: "linear-gradient(135deg, #1890ff 0%, #0097e6 100%)",
                    //   inactiveTextColor: "#595959",
                    //   hoverBackground: "#e0e0e0",
                    // },
                    {
                      value: "waiting",
                      label: "En Attente",
                      activeBackground: "linear-gradient(135deg, #b51804 0%, #cf2d19 100%)",
                      inactiveTextColor: "#b51804",
                      hoverBackground: "#fdecea",
                    },
                    {
                      value: "paid",
                      label: "Encaissée",
                      activeBackground: "linear-gradient(135deg, #e39c02 0%, #f0b429 100%)",
                      inactiveTextColor: "#e39c02",
                      hoverBackground: "#fff7e6",
                    },
                    {
                      value: "done",
                      label: "Comptabilisée",
                      activeBackground: "linear-gradient(135deg, #059e23 0%, #1bb33a 100%)",
                      inactiveTextColor: "#059e23",
                      hoverBackground: "#edfdf0",
                    },
                  ].map((item) => (
                    <Button
                      key={item.value}
                      onClick={() => handleOptionChange({ target: { value: item.value } })}
                      style={{
                        padding: "6px 14px",
                        borderRadius: 20,
                        border: "none",
                        cursor: "pointer",
                        fontSize: 13,
                        fontWeight: 500,
                        transition: "all 0.3s ease",
                        background: selectedOption === item.value
                          ? item.activeBackground
                          : "#f0f0f0",
                        color: selectedOption === item.value ? "#fff" : item.inactiveTextColor,
                        boxShadow: selectedOption === item.value
                          ? "0 3px 10px rgba(24, 144, 255, 0.4)"
                          : "0 1px 3px rgba(0, 0, 0, 0.1)",
                      }}
                      onMouseEnter={(e) => {
                        if (selectedOption !== item.value) {
                          e.currentTarget.style.background = item.hoverBackground;
                          e.currentTarget.style.transform = "translateY(-1px)";
                        }
                      }}
                      onMouseLeave={(e) => {
                        if (selectedOption !== item.value) {
                          e.currentTarget.style.background = "#f0f0f0";
                          e.currentTarget.style.transform = "translateY(0)";
                        }
                      }}
                    >
                      {item.label}
                    </Button>
                  ))}
                </div>
              </Col>
            </Row>
            <Row justify="end">

              <Col span={24} style={{ textAlign: "right" }}>
                <Space
                  style={{ display: "flex", justifyContent: "flex-end" }}
                >

                  {/* <Dropdown overlay={menu} */}
                  <Button className="buttonRegle" disabled={!isRgFactEnabled} onClick={openModal}>
                    Saisie  Encaissement
                  </Button>
                  {/* </Dropdown> */}

                  <Button
                    icon={<CalculatorOutlined />}
                    className="buttonCompta"
                    disabled={!isComptaEnabled}
                    onClick={handleComptabiliser}
                  >
                    Comptabiliser
                  </Button>
                  <Dropdown overlay={gestionMenu1} trigger={["click"]}>
                    <Button
                      icon={<MoreOutlined />}
                    //disabled={!isOtherButtonsEnabled}
                    />
                  </Dropdown>
                </Space>
              </Col>
            </Row>

          </Col>
        </Row>

        {/*  <Row justify="end">
               
                <Col span={24} style={{ textAlign: "right" }}>
                  <Space
                    style={{ display: "flex", justifyContent: "flex-end" }}
                  >
           
                    <Dropdown overlay={menu} disabled={!isRgFactEnabled}>
                      <Button className="buttonRegle">
                        Encaissement Facture(s) <DownOutlined />
                      </Button>
                    </Dropdown>

                    <Button
                      icon={<CalculatorOutlined />}
                      className="buttonCompta"
                      disabled={!isComptaEnabled}
                       onClick={handleComptabiliser} 
                    >
                      Comptabiliser
                    </Button>
                    <Dropdown  overlay={gestionMenu1} trigger={["click"]}>
                      <Button
                        icon={<MoreOutlined />}
                        //disabled={!isOtherButtonsEnabled}
                      />
                    </Dropdown>
                  </Space>
                </Col>
              </Row> */}


        <Table
          scroll={{
            x: true,
          }}
          style={{ cursor: "pointer", whiteSpace: "nowrap", width: "100%" }}
          //  className="custom-header1-table"
          bordered
          dataSource={filteredData}
          rowSelection={rowSelection}
          rowKey={(record) => record.num_encaiss}
          rowClassName={(record) =>
            selectedRowKeys.includes(record.num_encaiss) ? "selected-row" : ""
          }
          className="custom-header2-table my-custom-table"
          pagination={{
            pageSizeOptions: ["5", "10", "20", "50", "100"], // Options disponibles pour la pagination
            showSizeChanger: true, // Permet à l'utilisateur de changer le nombre de lignes par page
            pageSize: pageSize, // Valeur actuelle du nombre de lignes par page
            onShowSizeChange: (current, size) => setPageSize(size), // Mise à jour de pageSize lors du changement
          }}
          loading={loading}
          columns={columns}
          showSorterTooltip={false}
        />
        <Modal
          style={{
            top: 20,
          }}
          title={
            <div>
              {currentFacture ? "Modification Facture" : "Ajout Facture"}
            </div>
          }
          open={isModalVisible}
          onCancel={handleCancel}
          maskClosable={false}
          footer={null}
        >
          <Form onFinish={onFinish} layout="vertical" form={form}>
            <Form.Item
              label="Société"
              name="codesoc"
              rules={[
                { required: true, message: "Veuillez saisir la société!" },
              ]}
            >
              <Select
                style={{ width: "100%" }}
                defaultValue={"--Selectionner--"}
                showSearch
              >
                {adherents.map((adherent) => (
                  <Option key={adherent.codeadht} value={adherent.codeadht}>
                    {`${adherent.codeadht} - ${adherent.intitule}`}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  label="Date facture"
                  name="date_facture"
                  rules={[
                    {
                      required: true,
                      message: "Veuillez sélectionner la date de la facture!",
                    },
                  ]}
                >
                  <DatePicker style={{ width: "100%" }} format="DD/MM/YYYY" disabledDate={(current) => current && current > dayjs().endOf('day')} />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  label="Date envoie"
                  name="date_envoie"
                  rules={[
                    {
                      required: true,
                      message: "Veuillez sélectionner la date de la facture!",
                    },
                  ]}
                >
                  <DatePicker
                    style={{ width: "100%" }}
                    format="DD/MM/YYYY"
                    disabledDate={(current) => current && current > dayjs().endOf('day')}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  initialValue={0}
                  label="Cotisation patronale"
                  name="montant_cotis_pat"
                  rules={[
                    {
                      required: true,
                      message: "Veuillez saisir le montant de la cotisation!",
                    },
                  ]}
                >
                  <Input type="number" onChange={calculateMontantNet} />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  initialValue={0}
                  label="Cotisation Salariale"
                  name="montant_cotis_sal"
                  rules={[
                    {
                      required: true,
                      message: "Veuillez saisir le montant de la cotisation!",
                    },
                  ]}
                >
                  <Input type="number" onChange={calculateMontantNet} />
                </Form.Item>
              </Col>


            </Row>
            <Row gutter={16}>
              {/*   <Col span={12}> */}
              {/*  <Form.Item
                  label="Autres"
                  name="autre"
                 
                >
                  <Input />
                </Form.Item> 
               </Col> */}
              <Col span={12}>
                <Form.Item
                  initialValue={0}
                  label="Montant Frais Mdx"
                  name="montant_fm"
                  rules={[
                    {
                      required: true,
                      message: "Veuillez saisir le montant des frais MDX!",
                    },
                  ]}
                >
                  <Input type="number" onChange={calculateMontantNet} />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  initialValue={0}
                  label="Montant Adhésion"
                  name="montant_adh"

                >
                  <InputNumber style={{ width: "100%" }} onChange={calculateMontantNet} />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  initialValue={0}
                  label="Montant Subvention"
                  name="montant_sub"
                >
                  <InputNumber
                    style={{ width: "100%" }}
                    onChange={calculateMontantNet}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  label="Nb. Participants"
                  name="nb_participants"

                >
                  <Input type="number" style={{ width: "100%" }} />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  label="Période"
                  name="periode"

                  rules={[
                    { required: true, message: "Veuillez saisir la période!" },
                  ]}
                >
                  <DatePicker
                    format="MMM-YYYY"
                    picker="month"
                    disabledDate={(current) => current && current > dayjs().endOf('day')}
                    style={{ width: "100%" }}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={24}>
                <div style={{ fontWeight: "bold", fontSize: "16px" }}>
                  Montant Net Facture : {formatNumber(montantNet)} FCFA
                </div>
              </Col>
            </Row>
            <div style={{ marginTop: "20px", textAlign: "right" }}>
              <Form.Item>
                <Button onClick={handleCancel} type="dashed" danger>
                  Annuler
                </Button>
                <Button
                  htmlType="submit"
                  type="primary"
                  style={{ backgroundColor: "#010f1c", marginLeft: 8 }}
                >
                  Valider
                </Button>
              </Form.Item>
            </div>
          </Form>
        </Modal>
      </Card>

      <DraggableModal
        title={
          selectedRowKeys.length > 0
            ? `${isEditMode ? "Modification" : "Encaissement"} Facture(s) Adhérent - ${tableData.find(record => record.num_encaiss === selectedRowKeys[0])?.intitule || "Aucun"}`
            : isEditMode
              ? "Modification Encaissement Facture Adhérent"
              : "Encaissement Facture Adhérent"
        }

        open={modalVisible}
        maskClosable={false}
        onCancel={handleModalCancel}
        onOk={handleModalOk}
        style={{ top: 20 }}
        width={1000}
      >
        <Form form={form} layout="vertical">
          <Row gutter={16}>
            <Col span={6}>
              <Form.Item
                name="type_encaiss"
                label="Type Encaissement"
                rules={[
                  {
                    required: true,
                    message: "Veuillez sélectionner un type de règlement",
                  },
                ]}
              >
                <Select
                  placeholder="- Sélectionner -"
                  onChange={handleTypeReglementChange}
                  value={selectedTypeReglement}
                  disabled={isTypeRegDisabled} // Désactive si "Virement" est sélectionné
                >
                  <Option value="V">Virement</Option>
                  <Option value="C">Chèque</Option>
                  <Option value="Compte">Compte Avance</Option>
                  <Option value="E">Espèce</Option>
                  <Option value="T">Transfert</Option>
                </Select>
              </Form.Item>
            </Col>
            {(selectedTypeReglement === "V" ||
              selectedTypeReglement === "C") && (
                <Form.Item
                  name="code_bque"
                  label="Banque"
                  rules={[
                    {
                      required: true,
                      message: "Veuillez sélectionner un type de règlement",
                    },
                  ]}
                >
                  <Select
                    style={{ width: 180 }}
                    onChange={handleCompteRattacheChange}
                  >
                    {journalRegData &&
                      journalRegData
                        .filter((journal) => journal.type === "BANQUE")
                        .map((journal) => (
                          <Option
                            key={journal.compte_rattache}
                            value={journal.compte_rattache}
                          >
                            {` ${journal.libelle}`}
                          </Option>
                        ))}
                  </Select>
                </Form.Item>
              )}
            {selectedTypeReglement === "Compte" && (
              <Form.Item
                label="Compte Avance"
                rules={[
                  {
                    required: true,
                    message: "Veuillez sélectionner un type de règlement",
                  },
                ]}
              >
                <Select
                  style={{ width: 180 }}
                  onChange={handleCompteRattacheChange}
                >
                  {journalRegData &&
                    journalRegData
                      .filter((journal) => journal.type === "")
                      .map((journal) => (
                        <Option key={journal.codej} value={journal.codej}>
                          {`${journal.libelle}`}
                        </Option>
                      ))}
                </Select>
              </Form.Item>
            )}
            {selectedTypeReglement === "T" && (
              <Form.Item
                label="Transfert"
                name="code_bque"
                rules={[
                  {
                    required: true,
                    message: "Veuillez sélectionner un type d'encaissement",
                  },
                ]}
              >
                <Select
                  style={{ width: 180 }}
                  onChange={handleCompteRattacheChange}
                >
                  {journalRegData &&
                    journalRegData
                      .filter((journal) => journal.type === "TRANSFERT")
                      .map((journal) => (
                        <Option
                          key={journal.compte_rattache}
                          value={journal.compte_rattache}
                        >
                          {`${journal.libelle}`}
                        </Option>
                      ))}
                </Select>
              </Form.Item>
            )}

            <Col span={6}>
              <Form.Item
                name="num_cheque"
                label={`N° ${selectedTypeReglement
                  ? typeReglementLabels[selectedTypeReglement]
                  : ""
                  }`}
                rules={[
                  { required: true, message: "Numéro de facture requis" },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                name="date_encaiss"
                label="Date Encaissement"
                initialValue={dayjs()}
                rules={[
                  { required: true, message: "Date d'encaissement requise" },
                ]}
              >
                <DatePicker
                  style={{ width: "100%" }}
                  format="DD/MM/YYYY"
                  disabledDate={(current) => current && current > dayjs().endOf('day')}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={24}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginBottom: "16px",
                }}
              >
                <span>
                  <strong>Total à encaisser : {formatNumber(totalFacturesInitial)} FCFA
                  </strong>
                </span>
                {/* {!isEditMode && ( )} */}
                <span>
                  <strong>Solde Banque ce jour: </strong>
                  <strong color="#59e60e">{solde.solde || 0}</strong>
                </span>
              </div>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={12}>
              <Row gutter={16}>
                <Col span={20}>
                  <Form.Item name="date_trait" label="Mois traitement">
                    <Input
                      value={selectedDate}
                      style={{ width: "100%" }}
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col span={4}>
                  <div style={{ paddingTop: "30px" }}>
                    <Popover
                      placement="bottomCenter"
                      content={
                        <DatePicker
                          format="MMM-YYYY"
                          picker="month"
                          value={selectedDate}
                          onChange={(date) => setSelectedDate(date)}
                          disabledDate={(current) => current && current > dayjs().endOf('day')}
                        />
                      }
                      trigger="click"
                    >
                      <Button icon={<CalendarOutlined />} />
                    </Popover>
                  </div>
                </Col>
              </Row>
            </Col>

            <Col span={12}>

              <Space direction="vertical" style={{ textAlign: "left" }}>
                <strong>Encaissement(s) sélectionné(s) :</strong>
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap", // Permet de passer à la ligne automatiquement
                    //  justifyContent: "center", // Centre les colonnes
                    gap: "20px"
                  }}
                >
                  {selectedRowKeys.length > 0 ? (

                    selectedRowKeys.reduce((rows, numEncaiss, index) => {
                      const selectedRecord = tableData.find(record => record.num_encaiss === numEncaiss);

                      if (index % 2 === 0) {
                        rows.push([]);
                      }

                      rows[rows.length - 1].push(
                        <div
                          key={numEncaiss}
                          style={{
                            display: "flex",
                            flexDirection: "column", // Les éléments restent en colonne
                            alignItems: "left",
                            gap: "5px",
                            marginBottom: "10px"
                          }}
                        >
                          <strong>{selectedRecord?.motif_2 || "aucune"}</strong>
                          <InputNumber
                            style={{ width: "150px", }}
                            //className="align-right"
                            value={montantsModifies[numEncaiss] || 0}
                            onChange={(value) => {
                              setMontantsModifies((prev) => ({
                                ...prev,
                                [numEncaiss]: value,
                              }));
                              setMontantEncaissement(
                                Object.values({ ...montantsModifies, [numEncaiss]: value })
                                  .reduce((acc, val) => acc + val, 0)
                              );
                            }}
                          />
                        </div>
                      );

                      return rows;
                    }, []).map((group, index) => (
                      <div key={index} style={{ display: "flex", flexDirection: "column", gap: "10px" }} >
                        {group}
                      </div>
                    ))
                  ) : (
                    <span>Aucune facture sélectionnée</span>
                  )}
                </div>
              </Space>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={24}>
              <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "10px" }}>

                <strong>Montant Encaissement : {formatNumber(montantEncaissement)} FCFA
                </strong>
              </div>

            </Col>
          </Row>
        </Form>
      </DraggableModal>

      <DraggableModal
        title="Aperçu écritures au journal"
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        maskClosable={false}
        footer={[
          <Button
            className="buttonExport"
            onClick={() =>
              exportExcel(
                prepareDataForExport(comptaPreviewData),
                "Aperçu Ecriture au Journal.xlsx"
              )
            }
          >
            Export
          </Button>,
          <Button
            key="back"
            className="buttonClose"
            onClick={() => setIsModalOpen(false)}
          >
            Fermer
          </Button>,
          <Button
            className="Buttonvalid"
            disabled={solde1 !== 0}
            onClick={handleValidCompta}
          >
            Valider
          </Button>,
        ]}
        width={1200}
        style={{ top: 20 }}
      >
        <Input
          placeholder="Recherche..."
          bordered={false}
          style={{
            borderBottom: "2px solid #030303",
            width: "20%",
            marginBottom: 30,
          }}
        />
        <Table
          scroll={{
            x: true,
            // y: "240px",
          }}
          className="custom-header2-table"
          style={{ cursor: "pointer", whiteSpace: "nowrap", width: "100%" }}
          bordered
          showSorterTooltip={false}
          dataSource={comptaPreviewData}
          columns={columns1}
          footer={() => (
            <div style={{ textAlign: "right" }}>
              <Space>
                <strong>
                  Total Débit : {formatNumber(totalDebit1)}
                </strong>
                <strong>
                  Total Crédit : {formatNumber(totalCredit1)}
                </strong>
                <strong> Solde : {formatNumber(solde1)}</strong>
              </Space>
            </div>
          )}
        />
      </DraggableModal>
    </div>
  );
};

export default FacsSocs;
